import React from 'react'
import { Link } from 'react-router-dom'

const getIcon = (title) => {
  switch (title) {
    case 'STAFF':
      return (
        <svg
          className="w-16 h-16 text-primary-600 group-hover:text-primary-700 transition-colors"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      )
    case 'PENDING':
      return (
        <svg
          className="w-16 h-16 text-primary-600 group-hover:text-primary-700 transition-colors"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      )
    case 'ON QUEUE':
      return (
        <svg
          className="w-16 h-16 text-primary-600 group-hover:text-primary-700 transition-colors"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          />
        </svg>
      )
    default:
      return null
  }
}

export default ({ to, title, notificationCount }) => (
  <Link to={to}>
    <button className="group relative w-full bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 p-8 min-h-[200px] flex flex-col items-center justify-center focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
      {notificationCount !== undefined && notificationCount > 0 && (
        <div className="absolute top-4 right-4 bg-red-600 text-white text-sm font-bold rounded-full w-10 h-10 flex items-center justify-center shadow-lg">
          {notificationCount}
        </div>
      )}

      <div className="mb-4">{getIcon(title)}</div>

      <h3 className="text-xl font-semibold text-gray-900 group-hover:text-primary-600 transition-colors text-center">
        {title}
      </h3>
    </button>
  </Link>
)
